<template>
    <v-card
        component="CharacterFilter"
        :disabled="getActorsLoading"
        :class="[
            { isSmallScreen: getIsSmallScreen },
            { isSmallerScreen: getIsSmallerScreen },
            { 'small-design': $vuetify.breakpoint.sm },
        ]"
    >
        <v-card-actions class="tabs">
            <btn
                :text="'Man'"
                radius="mediumBottom"
                istab="true"
                :icon="'male'"
                :color="getGenderTabColor('m')"
                @click="setGender('m')"
            />
            <btn
                :text="'Woman'"
                radius="mediumBottom"
                istab="true"
                :icon="'female'"
                :color="getGenderTabColor('f')"
                @click="setGender('f')"
            />
            <!--            <div class="line"></div>-->
            <div class="ml-auto align-self-center color-picker">
                <div class="color" :style="{ background: getColorById(character.farba) }">&nbsp;</div>
            </div>
        </v-card-actions>

        <div class="row">
            <div class="input checkbox">
                <label for="hlboky"
                    >Deep voice
                    <input id="hlboky" type="checkbox" v-model="filters.hlboky" @change="setDeepVoice" />
                    <span></span>
                </label>
            </div>
            <div class="input checkbox">
                <label for="vysoky"
                    >High voice
                    <input id="vysoky" type="checkbox" v-model="filters.vysoky" @change="setHighVoice" />
                    <span></span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="input checkbox">
                <label for="is_top_30"
                    >TOP 30
                    <input id="is_top_30" type="checkbox" v-model="filters.is_top_30" @change="onFiltersUpdate" />
                    <span></span>
                </label>
            </div>
            <div class="input checkbox">
                <label for="photo"
                    >Photo
                    <input id="photo" type="checkbox" v-model="filters.photo" @change="onFiltersUpdate" />
                    <span></span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="input checkbox">
                <label for="drsny"
                    >Harsh voice
                    <input id="drsny" type="checkbox" v-model="filters.drsny" @change="onFiltersUpdate" />
                    <span></span>
                </label>
            </div>
            <div class="input checkbox">
                <label for="amatersky"
                    >Amateur voice
                    <input id="amatersky" type="checkbox" v-model="filters.amatersky" @change="onFiltersUpdate" />
                    <span></span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="input checkbox">
                <label for="detsky"
                    >Child voice
                    <input id="detsky" type="checkbox" v-model="filters.detsky" @change="onFiltersUpdate" />
                    <span></span>
                </label>
            </div>
        </div>

        <div class="inputs" ref="inputs">
            <label v-if="getIsSmallScreen">Age from</label>
            <v-text-field
                ref="age_from"
                class="input text"
                clearable
                v-model.number="filters.age_from"
                type="number"
                :class="{ thin: getIsSmallScreen }"
                :label="!getIsSmallScreen ? 'Age from' : ''"
                @click:clear="clear('age_from')"
                @change="onFiltersUpdate"
                hide-details
            />
            <label v-if="getIsSmallScreen" class="pl">Age to</label>
            <v-text-field
                ref="age_to"
                class="input text"
                v-model.number="filters.age_to"
                type="number"
                :label="!getIsSmallScreen ? 'Age to' : ''"
                @click:clear="clear('age_to')"
                @change="onFiltersUpdate"
                hide-details
                clearable
            />
            <label v-if="getIsSmallScreen">Price to</label>
            <v-text-field
                ref="price_to"
                class="input text"
                v-model.number="filters.price_to"
                type="number"
                :class="{ thin: getIsSmallScreen }"
                :label="!getIsSmallScreen ? 'Voice price to' : ''"
                @click:clear="clear('price_to')"
                @change="onFiltersUpdate"
                hide-details
                clearable
            />
            <label v-if="getIsSmallScreen" class="pl">Type</label>
            <v-select
                class="input select"
                v-model="filters.type"
                item-text="name"
                item-value="id"
                :items="characterTypes"
                :label="!getIsSmallScreen ? 'Type' : ''"
                @change="onFiltersUpdate"
                hide-details
            />
            <location-selects v-model="filters.location_id" @change="onFiltersUpdate" />
        </div>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import _pick from 'lodash/pick';

import LocationSelects from '@/components/.global/LocationSelects.vue';
import { defaultCharacterFilters } from '@/store/Admin/CharacterStore';
import { EnumsApi } from '@/api';

export default {
    name: 'CharacterFilter',

    components: {
        LocationSelects,
    },

    data() {
        return {
            fatalError: false,
            showColorPicker: false,
            characterTypes: [
                { id: 1, name: 'TV' },
                { id: 2, name: 'RADIO' },
            ],
            locations: {
                state: null,
                county: null,
                records: [],
            },
        };
    },

    async mounted() {
        this.readCharacterFilters();
    },

    methods: {
        ...mapActions(['setCharacter', 'loadCities', 'loadActors', 'updateCharacter']),
        ...mapMutations(['setSearchIsVisible', 'appendActorsFilters']),

        async loadLocations() {
            const { data } = await EnumsApi.loadLocations({
                include: ['type', 'parent', 'parent.type'],
                sort: ['type_id.asc', 'parent_id.asc', 'name.asc'],
            });
            this.locations.records = data.records;
        },

        readCharacterFilters() {
            this.filters = _pick(
                { ...defaultCharacterFilters, ...(this.character?.filter ?? {}) },
                Object.keys(defaultCharacterFilters)
            );
        },

        setGender(gender) {
            this.filters.pohlavie = gender;
            this.onFiltersUpdate();
        },

        setDeepVoice() {
            if (this.filters.hlboky && this.filters.vysoky) {
                this.filters.vysoky = false;
            }
            this.onFiltersUpdate();
        },

        setHighVoice() {
            if (this.filters.hlboky && this.filters.vysoky) {
                this.filters.hlboky = false;
            }
            this.onFiltersUpdate();
        },

        clear(prop) {
            this.filters[prop] = null;
            this.$refs[prop]?.blur();
            this.onFiltersUpdate();
        },

        onFiltersUpdate() {
            this.character.filter = _pick(this.filters, Object.keys(defaultCharacterFilters));
            this.setSearchIsVisible(false);
            this.updateCharacter(this.character);
            this.load();
        },

        load() {
            this.appendActorsFilters({
                ...this.filters,
                // Reset
                search: undefined,
                page: 1,
            });
            this.loadActors();
        },
    },

    computed: {
        ...mapGetters({
            character: 'getSelectedCharacter',
        }),

        ...mapGetters([
            'getActorsFilters',
            'getActorsLoading',
            'getColorById',
            'getIsSmallScreen',
            'getIsSmallerScreen',
        ]),

        getGenderTabColor() {
            return (gender) => (this.character?.filter?.pohlavie === gender ? '' : 'ghostLight');
        },

        filters: {
            get() {
                return this.getActorsFilters;
            },
            set(value) {
                this.appendActorsFilters(value);
            },
        },
    },

    watch: {
        character() {
            this.readCharacterFilters();
            this.load();
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='CharacterFilter'].isSmallScreen {
    height: 285px;

    .tabs {
        margin-bottom: 10px;

        .line {
            display: none;
        }
    }

    .row {
        .input {
            label {
                height: 22px;
                font-size: 14px;

                span {
                    height: 15px;
                    width: 15px;
                    min-width: 15px;

                    &:after {
                        height: 15px;
                        width: 15px;
                        min-width: 15px;
                    }
                }
            }
        }
    }

    .inputs,
    /deep/ [component='LocationSelects'] {
        margin-top: 8px;

        .input {
            width: 40%;
            margin: 3px 0;
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #d6d6d6;
            padding: 0 0 0 7px;
            height: 26px;
            align-items: center;

            &.thin {
                width: 20%;
            }
        }

        label {
            width: 20%;
            margin: 0;
            display: flex;
            align-items: center;

            &.pl {
                padding-left: 8px;
            }
        }
    }

    /deep/ [component='LocationSelects'] {
        width: 100%;

        .input {
            width: 80%;
        }
    }
}

[component='CharacterFilter'] {
    display: block;
    padding: 15px;
    height: 338px;
    margin: 16px 0;
    padding-top: 0;

    .tabs {
        position: relative;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        padding: 0;
        margin-bottom: 15px;

        .line {
            width: 100%;
            height: 1px;
            background: @dark_dk;
            position: absolute;
            bottom: 0px;
            left: 0px;
        }
    }

    &.small-design {
        height: auto;
        margin: 0 0 10px 0;
    }

    .color-picker {
        position: relative;
        transform: translate(8px, 3px);

        .color {
            width: 50px;
            border-radius: 4px;
            height: 22px;
        }
    }

    .row {
        margin: 0;

        .input {
            margin: 0;
            width: 50%;
            .flex-row;

            label {
                height: 30px;
            }
        }
    }

    .inputs,
    /deep/ [component='LocationSelects'] {
        display: flex;
        flex-wrap: wrap;

        .input {
            width: 50%;
            margin: 10px 0 0;

            &:nth-child(odd) {
                padding-right: 5px;
            }

            &:nth-child(even) {
                padding-left: 5px;
            }
        }
    }
}
</style>
